import React, { FC } from "react";
import { NavLink } from "react-router-dom";
import './Navbar.css'
import {logo} from '../../assets'
import DesktopNavbar from "./desktop/DesktopNavbar";
import MobileNavbar from "./mobile/MobileNavbar";
import { navLinks } from "./links/links-data";

interface NavLinkItem {
    name: string;
    path: string;
}

const Navbar: FC = () => {

    return(
        <div className="nav-container">
            <DesktopNavbar navLinks={navLinks}/>
            <MobileNavbar navLinks={navLinks}/>
        </div>
    );
};

export default Navbar;
